/**
 * Define the possible data that a sub content component can expose
 */
import { BroadcastService } from '../service/broadcast.service';
import { SubContentEventType } from './sub-content.model';
import { ElementRef } from '@angular/core';

export abstract class SubContent {
	// Needs to be public to be allow to the polymorphism to access when creating the instance
	public isSubContentPanelOpen = false;
	public data: any;
	public successEvent: any;
	public errorEvent: any;
	public updateEvent: any;
	notificationEvent: any;
	elementRef: ElementRef;
	public routeParams: any;

	protected constructor(public broadcastService: BroadcastService) {
		//
	}

	/**
   * Open the Sub Content
   */
	openSubContent(width: string = null, callback: () => any = null): void {
		this.broadcastService.broadcast({
			name: SubContentEventType.OPEN_CLOSE,
			event: {
				open: true,
				width: width,
				callback: callback
			}
		});
	}

	/**
   * Close the Sub Content successfully
   */
	public onSuccessCloseSubContent(result: any): void {
		this.successEvent.emit(result);
		this.closeSubContent();
	}

	/**
   * Close the Sub Content with Error
   */
	public onErrorCloseSubContent(result: any): void {
		this.errorEvent.emit(result);
		this.closeSubContent();
	}

	/**
   * Close the Sub Content Panel
   */
	public closeSubContent(): void {
		this.broadcastService.broadcast({
			name: SubContentEventType.OPEN_CLOSE,
			event: {
				open: false
			}
		});
	}

	/**
	 * Show Notification message on the sub-content component.
	 * @param message: string
	 */
	protected showNotification(message: string): void {
		this.notificationEvent.emit(message);
	}

	/**
	 * Returns the nativeElement from SubContent component.
	 */
	protected getParentNativeElement(): any {
		return this.elementRef ? this.elementRef.nativeElement : null;
	}
}
